import { DownloadFileType } from "./types";

export const invoiceQueryKeys = {
  all: ["invoices"] as const,
  bulkUploads: {
    list: (userId: string) =>
      [...invoiceQueryKeys.all, "bulk", "list", userId] as const,
    entity: (userId: string, bulkUploadId: string) =>
      [
        ...invoiceQueryKeys.all,
        "bulk",
        "entity",
        userId,
        bulkUploadId,
      ] as const,
    download: (userId: string, type: DownloadFileType, uploadId?: string) => {
      const base = [
        ...invoiceQueryKeys.all,
        "bulk",
        "download",
        userId,
        type,
      ] as const;
      return uploadId ? ([...base, uploadId] as const) : base;
    },
  },
  recurringInvoice: {
    list: (userId: string) =>
      [...invoiceQueryKeys.all, "recurring", "list", userId] as const,
    entity: (userId: string, recurringInvoiceId: string) =>
      [
        ...invoiceQueryKeys.all,
        "recurring",
        "entity",
        userId,
        recurringInvoiceId,
      ] as const,
  },
};

export default invoiceQueryKeys;
